import { Component } from "@theme/component";
import { ThemeEvents, VariantUpdateEvent } from "@theme/events";
import { assignVariantToMetafield } from "@theme/utilities";

export default class ProductDiscountContainer extends Component {
    #abortController = new AbortController();
    #discountSettings = [];

    connectedCallback() {
        super.connectedCallback();

        const { signal } = this.#abortController;
        const target = this.closest(".product-info");
        this.#discountSettings = this.#parseDiscountSettings();

        target?.addEventListener(
            ThemeEvents.variantUpdate,
            this.#onVariantChanged.bind(this),
            { signal },
        );
    }

    /**
     * @param {VariantUpdateEvent} event
     */
    #onVariantChanged(event) {
        if (!event?.detail?.sourceId) return;
        const variant =
            event.detail.data?.variant ||
            assignVariantToMetafield(
                event.detail.resource.variant,
                event.detail.resource.metafields,
            );
        if (!variant || !this.labelSpan) return;
        if (!variant.compare_at_price) {
            this.hidden = true;
            return;
        }
        const discountPercent = parseInt(
            100 - (variant.price / variant.compare_at_price) * 100,
        );
        if (discountPercent <= 0) {
            this.hidden = true;
            return;
        }
        this.hidden = false;
        if (!isNaN(discountPercent) && discountPercent > 0) {
            this.labelSpan.innerText = `${discountPercent}% off`;
        }
        this.#applyDiscountStyles(discountPercent);
    }

    get labelSpan() {
        return this.querySelector("span[label-discount]");
    }

    get labelBadge() {
        return this.querySelector(".discount-code__text");
    }

    #parseDiscountSettings() {
        const settingsScript = this.querySelector(
            "script[data-discount-settings]",
        );
        const raw = settingsScript?.textContent?.trim();
        if (!raw) return [];
        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    }

    #applyDiscountStyles(discountPercent) {
        if (!this.labelBadge) return;
        const match = this.#discountSettings.find((setting) => {
            const settingPercent = parseInt(setting?.percent, 10);
            return !isNaN(settingPercent) && settingPercent === discountPercent;
        });
        const { defaultBackground, defaultColor } = this.labelBadge.dataset;
        const background = match?.bg_color || defaultBackground;
        const color = match?.color || defaultColor;
        if (background) {
            this.labelBadge.style.backgroundColor = background;
        }
        if (color) {
            this.labelBadge.style.color = color;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
}

if (!customElements.get("product-discount-container")) {
    customElements.define(
        "product-discount-container",
        ProductDiscountContainer,
    );
}
